import { render, staticRenderFns } from "./CsAnimatedNumberGroup.vue?vue&type=template&id=2af8243c&"
import script from "./CsAnimatedNumberGroup.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsAnimatedNumberGroup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports